// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React,{useEffect} from "react";
import "./App.css";
import PvgHome from "./components/Pvg/PvgHome";
import ClickaCook from "./components/ClickaCooktwo/ClickaCook";
import IFMS_Home from "./components/IFMS/IFMS_Home";
function App() {

useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      alert('Right-click is disabled on this site');
      // console.log('Right-click is disabled for this content');

    };
    document.addEventListener('contextmenu', handleContextMenu);

    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);


  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<PvgHome />} />
          <Route path="/clickacook" element={<ClickaCook />} />
          <Route path="/IFMS_Home" element={<IFMS_Home />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
